/**
 * Italian — every string this portal says.
 *
 * Translated from the Slovenian original, which is the source of truth for the
 * vocabulary: the words for a stamp, a shift, a change to one and a decision about
 * leave are the words the rest of this product uses, and a second wording would be a
 * second feature as far as anybody comparing two screens is concerned.
 */
export default {
    app: {
        name: "Personale",
    },
    errors: {
        conflict: "Il record esiste già o è occupato",
        generic_error: "Si è verificato un errore",
        invalid_data: "Dati non validi",
        module_not_licensed: "Il modulo non è attivo per questa struttura",
        not_found: "Non trovato",
        on_add: "Errore durante l'aggiunta",
        on_edit: "Errore durante la modifica",
        on_load: "Errore durante il caricamento",
        operation_in_progress: "Questa timbratura si sta già registrando. Non premere di nuovo — tra un attimo sarà visibile.",
        operation_mismatch: "La schermata non è aggiornata. Ricarica la pagina e riprova.",
        session_expired: "La sessione è scaduta. Accedi di nuovo — non è stato fatto nulla.",
        staff_break_recording_off: "La struttura non registra le pause.",
        staff_not_employed: "Per quel giorno non hai una scheda personale valida, quindi la timbratura non si può registrare. Dillo al responsabile o all'ufficio del personale.",
        staff_time_busy: "La timbratura si sta registrando. Riprova tra un attimo.",
        staff_time_month_closed: "Questo mese è chiuso e non si può più modificare. Se si tratta di un errore, rivolgiti al responsabile — riaprirlo può solo l'ufficio del personale.",
        staff_time_out_of_range: "L'ora della timbratura è fuori dalla finestra consentita.",
        staff_time_sequence: "L'ordine delle timbrature non è possibile (per esempio un'entrata su una giornata già aperta).",
        unauthorized: "Non hai i permessi per questa azione",
    },
    general: {
        hint: 'Suggerimento',
        cancel: "Annulla",
        hide_password: "Nascondi la password",
        save: "Salva",
        show_password: "Mostra la password",
    },
    home: {
        needs_you: "Attende la tua risposta",
        no_shift_today: "Per oggi non è pubblicato nessun turno.",
        open_clock: "Tutte le timbrature",
        waiting_on_others: "Attende la risposta della struttura",
    },
    license: {
        contact: "Per l'attivazione rivolgiti all'amministratore di sistema. I dati della struttura restano intatti.",
        lead: "Il modulo «Personale e orario di lavoro» non fa parte dell'abbonamento di questa struttura, quindi questo portale non può mostrare nulla.",
        switch_account: "Accedi con un altro account",
        title: "Questo servizio non è attivo",
    },
    login: {
        demo_signing_in: "Accesso in corso …",
        demo_failed: "Questo ruolo non esiste su questo server.",
        failed: "Nome utente o password errati",
        password: "Password",
        remember: "Resta connesso",
        remember_hint: "Sul tuo telefono. Su un telefono altrui è meglio non restare connesso.",
        same_account: "Accedi con lo stesso nome utente e la stessa password del PMS. Qui la password non si può reimpostare — per quello rivolgiti all'amministratore.",
        submit: "Accedi",
        subtitle: "Il mio cartellino, il mio orario di lavoro, le mie ferie e i miei documenti.",
        title: "Accedi",
        username: "Nome utente",
    },
    nav: {
        account: "Account",
        clock: "Cartellino",
        documents: "Documenti",
        home: "Home",
        language: "Lingua",
        language_de: "Deutsch",
        language_en: "English",
        language_hr: "Hrvatski",
        language_hu: "Magyar",
        language_it: "Italiano",
        language_sl: "Slovenščina",
        leave: "Ferie",
        logout: "Esci",
        profile: "Il mio profilo",
        rota: "Orario",
        theme: "Aspetto",
        theme_dark: "Scuro",
        theme_light: "Chiaro",
        theme_system: "Sistema",
    },
    notifications: {
        channel_email: "E-mail",
        channel_email_hint: "Richiede il tuo indirizzo e-mail.",
        channel_messaging: "App di messaggistica",
        channel_messaging_hint: "Richiede il tuo numero WhatsApp o un Viber collegato a te.",
        channel_push: "App sul telefono",
        channel_push_hint: "Richiede un telefono o un orologio aziendale abbinato a te.",
        channel_sms: "SMS",
        channel_sms_hint: "Richiede il tuo numero di telefono.",
    },
    profile: {
        account_hint: "Chi sei nel sistema.",
        account_managed_elsewhere: "Nome, nome utente e password li gestisce l'amministratore di sistema. Qui non si possono modificare.",
        account_title: "Account",
        card_hint: "Che cosa ha registrato la struttura sul tuo lavoro.",
        card_read_only: "La scheda la gestisce l'ufficio del personale. Se qualcosa non torna, diglielo — una correzione è una scheda nuova, non una vecchia corretta.",
        card_title: "La mia scheda personale",
        channel_unavailable: "La struttura non ha (ancora) configurato questo canale.",
        channels: "Canali di avviso",
        channels_hint: "Se non scegli nulla valgono tutti i canali che la struttura ha. Un canale grigio è un canale che la struttura non ha configurato.",
        contact_hint: "Dove la struttura deve mandarti l'avviso sull'orario di lavoro. Questi dati sono tuoi e li gestisci tu.",
        contact_title: "I miei dati per gli avvisi",
        department: "Reparto",
        email: "E-mail",
        email_hint: "Qui arriva l'avviso di pubblicazione dell'orario e di modifica di un turno.",
        employee_no: "Numero interno",
        engagement: "Base giuridica",
        hours_per_week: "{hours} ore alla settimana",
        language_hint: "Vale per questo dispositivo. La lingua sull'account la imposta l'ufficio del personale e decide in quale lingua si apre il portale la prima volta.",
        manager: "Responsabile",
        name: "Nome",
        no_card: "Per oggi non c'è nessuna scheda valida.",
        no_card_hint: "È normale il primo giorno o tra una stagione e l'altra. Se stai lavorando, dillo all'ufficio del personale.",
        period: "Periodo",
        period_from: "dal {date}",
        phone: "Telefono",
        phone_hint: "In formato internazionale: +38641123456.",
        phone_invalid: "Il telefono deve essere nel formato +386… (da 8 a 15 cifre).",
        position: "Mansione",
        property: "Struttura",
        saved: "Salvato.",
        time_record: "Registro delle ore",
        time_record_not_required: "Non obbligatorio",
        username: "Nome utente",
        weekly_obligation: "Ore dovute alla settimana",
        work_pattern: "Distribuzione nei giorni",
        working_time: "Orario di lavoro",
    },
    staff: {
        acknowledge: "Ho preso visione",
        acknowledge_failed: "Non è stato possibile registrare la presa visione.",
        acknowledge_hint: "Con la presa visione nel registro resta scritto che hai visto la modifica, e quando. Finché non la confermi, chi prepara i turni vede che ancora non lo sai.",
        acknowledged: "Presa visione registrata",
        basis_agency_worker: "Lavoratore somministrato",
        basis_copyright_contract: "Contratto di cessione del diritto d'autore",
        basis_employment_contract: "Contratto di lavoro subordinato",
        basis_other: "Altra base giuridica",
        basis_pensioner_temporary: "Lavoro temporaneo di un pensionato",
        basis_self_employed: "Lavoratore autonomo",
        basis_service_contract: "Contratto d'opera",
        basis_short_term_family_work: "Lavoro familiare di breve durata",
        basis_student_work: "Lavoro studentesco",
        basis_traineeship: "Tirocinio o apprendistato",
        break_of: "pausa {minutes}",
        change_changed_at: "Modificato {at}",
        change_moved: "Da {previous} a {current}",
        change_reason_line: "Motivo: {reason}",
        change_withdrawn: "Il turno è annullato (era {previous})",
        day_friday: "ven",
        day_monday: "lun",
        day_saturday: "sab",
        day_sunday: "dom",
        day_thursday: "gio",
        day_tuesday: "mar",
        day_wednesday: "mer",
        decline: "Non posso",
        decline_failed: "Non è stato possibile registrare la risposta.",
        decline_hint: "Chi prepara i turni vedrà che non puoi e cercherà una sostituzione. La modifica resta nell'elenco finché la cosa non è sistemata.",
        decline_note: "Perché non puoi? (facoltativo)",
        decline_send: "Invia",
        decline_title: "Non posso lavorare",
        declined: "Registrato: non puoi.",
        duration_fixed_term: "Tempo determinato",
        duration_indefinite: "Tempo indeterminato",
        exempt_managing_person: "Persona con funzioni dirigenziali",
        exempt_other: "Altro motivo",
        free_day: "Libero",
        load_failed: "Non è stato possibile leggere i dati.",
        my_changes_title: "Modifiche di cui non hai ancora preso visione: {count}",
        my_pending_title: "Richieste in attesa di decisione: {count}",
        my_rota: "Il mio orario di lavoro",
        my_rota_empty: "Questa settimana non hai nessun turno assegnato.",
        my_rota_empty_hint: "Quello che vedi qui è solo ciò che è pubblicato. Le bozze di chi prepara i turni non si vedono — finché una settimana non è pubblicata, non è una promessa.",
        next_week: "Settimana prossima",
        no_swap_hint: "Lo scambio di un turno con un collega e la richiesta di sostituzione in questo portale non ci sono. Se non puoi lavorare un turno, premi «Non posso» sulla modifica qui sopra — il responsabile lo vede subito, motivo compreso. Per un'assenza programmata invia una richiesta di ferie.",
        previous_week: "Settimana scorsa",
        record_clock: "Timbrature",
        record_manual: "Inserimento manuale",
        record_pattern: "Modello di lavoro",
        record_schedule: "Orario di lavoro",
        state_cancelled: "Annullato",
        state_draft: "Bozza",
        state_published: "Pubblicato",
        this_week: "Questa settimana",
        time_full: "Tempo pieno",
        time_part: "Tempo parziale",
        today: "Oggi",
        try_again: "Riprova",
        unit_hours: "h",
        unit_minutes: "min",
    },
    staff_absence: {
        days_recorded: "Giorni registrati: {count}",
        decided_by_other: "Sulla richiesta decide qualcun altro — la tua non la puoi approvare da solo.",
        from: "Dal",
        kind: "Tipo",
        kind_business_trip: "Trasferta",
        kind_holiday: "Festività",
        kind_other: "Altro",
        kind_sick_leave: "Malattia",
        kind_training: "Formazione",
        kind_unexcused: "Assenza ingiustificata",
        kind_vacation: "Ferie",
        my_absences: "Le mie assenze",
        my_absences_hint: "Le tue richieste e le decisioni prese su di esse. Quelle respinte restano visibili — un rifiuto che sparisce è un rifiuto che non è avvenuto.",
        no_my_requests: "Non hai richieste di assenza.",
        note: "Nota",
        other_kinds_hint: "Si possono richiedere solo le ferie. La malattia la comunichi al responsabile, che la inserisce nel registro; la festività deriva dal calendario della struttura; formazione e trasferta sono una disposizione del datore di lavoro. Tutto questo compare nel tuo registro quando viene inserito.",
        other_kinds_title: "Altre assenze",
        range_backwards: "La fine non può essere prima dell'inizio.",
        range_too_long: "Una richiesta può coprire al massimo {days} giorni. Per un'assenza più lunga i giorni li inserisce il responsabile.",
        request_hint: "Per te puoi richiedere le ferie. La malattia si comunica e si registra, la festività deriva dal calendario, formazione e trasferta le inserisce il responsabile.",
        request_leave: "Richiedi le ferie",
        request_sent: "La richiesta è stata inviata per la decisione.",
        send_request: "Invia la richiesta",
        source_calendar: "Calendario delle festività",
        source_manager: "Inserimento del responsabile",
        source_request: "Richiesta",
        state_approved: "Approvato",
        state_rejected: "Respinto",
        state_requested: "Richiesto",
        state_withdrawn: "Ritirato",
        to: "Al",
        total_absence: "Assenza",
        withdraw: "Ritira",
        withdrawn: "La richiesta è stata ritirata.",
    },
    staff_document: {
        download: "Scarica",
        expired_on: "Scaduto il {date}",
        expires_on: "Valido fino al {date}",
        kind_aneks: "Appendice contrattuale",
        kind_drugo: "Altro",
        kind_m1: "Modulo M-1",
        kind_nda: "Dichiarazione di riservatezza",
        kind_odlok: "Provvedimento",
        kind_pogodba: "Contratto di lavoro",
        my_documents: "I miei documenti",
        my_documents_hint: "Quello che la struttura ha depositato nel tuo fascicolo. Tu leggi e scarichi; deposita la struttura.",
        no_my_documents: "Per te non è ancora stato depositato nessun documento.",
        read_only_hint: "Qui i documenti non si possono aggiungere né eliminare — il fascicolo è il registro del datore di lavoro. La conferma di ricezione ce l'ha solo il provvedimento sulle ferie.",
    },
    staff_month: {
        badge_closed: "Chiuso",
    },
    staff_time: {
        break_counts_hint: "La pausa conta come orario di lavoro e non viene detratta.",
        break_short: "pausa {minutes}",
        correction_approved: "Approvato",
        correction_date: "Data",
        correction_decided_by_other: "Sulla richiesta decide qualcun altro — la tua non la puoi approvare da solo.",
        correction_hint: "Puoi richiederla tu; decide qualcun altro.",
        correction_kind: "Tipo di timbratura",
        correction_mode_existing: "Correzione di una timbratura esistente",
        correction_mode_missing: "Timbratura mancante",
        correction_no_stamps: "Questo giorno non ha nessuna timbratura da correggere.",
        correction_reason: "Motivo",
        correction_rejected: "Respinto",
        correction_requested: "Richiesto",
        correction_send: "Invia la richiesta",
        correction_sent: "La richiesta è stata inviata per la decisione.",
        correction_time: "Ora",
        correction_what: "Che cosa correggi",
        correction_which_stamp: "Quale timbratura",
        day_open: "La giornata non è chiusa — l'uscita non è registrata.",
        decision_reason: "Motivo: {reason}",
        excess_pending: "Eccedenza — attende la classificazione",
        first_in: "entrata {at}",
        kind_break_end: "Fine della pausa",
        kind_break_start: "Pausa",
        kind_clock_in: "Entrata",
        kind_clock_out: "Uscita",
        last_out: "uscita {at}",
        month_pdf: "Prospetto mensile (PDF)",
        my_corrections: "Le mie richieste di correzione",
        my_record: "Il mio registro",
        my_time: "Il mio cartellino",
        next_month: "Mese prossimo",
        no_days: "In questo periodo non ci sono giorni registrati.",
        of_which_break: "di cui pausa {minutes}",
        open: "Non concluso",
        period_month: "Mese",
        period_week: "Settimana",
        previous_month: "Mese scorso",
        queued: "In attesa di connessione: {count}",
        refused: "La timbratura non è stata accettata.",
        not_recorded: "La timbratura non è stata registrata: {reason}",
        request_correction: "Richiedi una correzione",
        stamped: "Registrato: {kind}",
        this_month: "Questo mese",
        today_total: "Oggi",
        total_balance: "Saldo",
        total_break: "Pausa",
        total_expected: "Ore dovute",
        total_worked: "Lavoro",
    },
    staff_vacation: {
        acknowledge: "Ho preso visione",
        acknowledge_hint: "Confermi la RICEZIONE del provvedimento, non l'accordo sul numero di giorni.",
        acknowledged: "Presa visione",
        acknowledged_toast: "La ricezione del provvedimento è registrata.",
        available: "Disponibili",
        bucket_current: "Nuove",
        bucket_old: "Vecchie",
        current_leave: "Ferie annuali {year}",
        days_count: "{count} giorni",
        decision_for_year: "Provvedimento per l'anno {year}",
        decision_total: "Assegnate: {days}",
        entitled: "Assegnate",
        expired_days: "Scadute {days} — il termine era {date}.",
        issued_at: "Emesso da: {who}, {at}",
        my_balance: "Le mie ferie",
        my_decisions: "I miei provvedimenti",
        my_decisions_hint: "I provvedimenti sull'assegnazione delle ferie annuali che la struttura ha emesso per te.",
        next_year: "Anno prossimo",
        no_balance: "Per quest'anno non ci sono dati sulle ferie.",
        no_balance_hint: "Il saldo nasce quando è emesso un provvedimento e quando la persona ha un periodo di lavoro valido.",
        no_my_decisions: "Per te non è ancora stato emesso nessun provvedimento.",
        no_usage: "In quest'anno non è registrato nessun utilizzo delle ferie.",
        not_acknowledged: "Presa visione mancante",
        not_issued_hint: "Il provvedimento per quest'anno non è ancora stato emesso.",
        of_which_pending: "Di cui in attesa di decisione: {days}",
        of_which_used: "Di cui usufruite: {days}",
        old_leave: "Ferie vecchie ({year})",
        over_remaining: "La richiesta supera i {days} disponibili. La decisione spetta comunque alla struttura.",
        part_base: "Base",
        part_children: "Figli",
        part_education: "Istruzione",
        part_full_year: "Totale (anno intero)",
        part_responsibility: "Mansione di responsabilità",
        part_special: "Categoria particolare",
        part_tenure: "Anzianità di servizio",
        pdf: "PDF",
        pending: "In decisione",
        previous_year: "Anno scorso",
        requested_days: "Giorni lavorativi richiesti: {days}",
        still_days: "ancora {days}",
        still_of: "ancora {left} di {total}",
        this_year: "Quest'anno",
        usage_history: "Storico dell'utilizzo",
        use_by: "Usufruiscine entro il {date}.",
        used: "Usufruite",
    },
    success: {
        add: "Aggiunto con successo",
        edit: "Aggiornato con successo",
    },
    validation: {
        email: "Indirizzo e-mail non valido",
        required: "Questo campo è obbligatorio",
    },
}
